// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__f_l0m","primary":"Button_primary__gNjMo","alternate":"Button_alternate__ycj_v","faded":"Button_faded__P4adT","content":"Button_content__2NGmZ"};